import { render, staticRenderFns } from "./FormBlock.vue?vue&type=template&id=c9a5665c&scoped=true&"
import script from "./FormBlock.vue?vue&type=script&lang=ts&"
export * from "./FormBlock.vue?vue&type=script&lang=ts&"
import style0 from "./FormBlock.vue?vue&type=style&index=0&id=c9a5665c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a5665c",
  null
  
)

export default component.exports